import { render, staticRenderFns } from "./ClientComputer.vue?vue&type=template&id=8bd2ebc0&scoped=true&"
import script from "./ClientComputer.vue?vue&type=script&lang=js&"
export * from "./ClientComputer.vue?vue&type=script&lang=js&"
import style0 from "./ClientComputer.vue?vue&type=style&index=0&id=8bd2ebc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd2ebc0",
  null
  
)

export default component.exports